import React from "react";
import { Link } from "react-router-dom";
import "../style/Technical.css"; // external CSS
import { useNavigate } from "react-router-dom";
import logo from "../assets/images/teteklogo-removebg-preview.png";

const MockTest = () => {
  const navigate = useNavigate();

const startTest = (topic) => {
  navigate("/ques", { state: { topic } }); // 👈 pass topic as state
};

  return (
    <div className="technical__mock-container">
      {/* Header */}
      <div className="technical__header">
        <div className="technical__company-name">
          <img src={logo} alt="Logo" style={{ height: "45px", objectFit: "contain" }} />
        </div>
        <div className="technical__title">Technical Round</div>
      </div>

      {/* Card Grid */}
      <div className="technical__card-grid">
        <div className="technical__card" >
          <img
            src="https://cdn-icons-png.flaticon.com/512/2721/2721297.png"
            alt="Developer"
            className="technical__card-image"
          />
          <h2 className="technical__card-title">Developer</h2>
          <Link to="/developer" className="technical__start-btn">
            Start Test
          </Link>
        </div>

        <div className="technical__card">
          <img
            src="https://cdn-icons-png.flaticon.com/512/4355/4355942.png"
            alt="Hardware"
            className="technical__card-image"
          />
          <h2 className="technical__card-title">Hardware Engineer</h2>
          <Link to="/hardware" className="technical__start-btn">
            Start Test
          </Link>
        </div>

        <div className="technical__card" >
          <img
            src="https://cdn-icons-png.flaticon.com/512/4204/4204600.png"
            alt="Marketing"
            className="technical__card-image"
          />
          <h2 className="technical__card-title">Digital Marketing</h2>
          <Link to="/digital" className="technical__start-btn">
            Start Test
          </Link>
        </div>

        <div className="technical__card" onClick={() => startTest("hr")}>
          <img
            src="https://cdn-icons-png.flaticon.com/512/4140/4140039.png"
            alt="Designer"
            className="technical__card-image"
          />
          <h2 className="technical__card-title">HR & Admin</h2>
          <Link to="/ques" className="technical__start-btn">
            Start Test
          </Link>
        </div>

        <div className="technical__card" onClick={() => startTest("accounts")}>
          <img
            src="https://cdn-icons-png.flaticon.com/512/8202/8202353.png"
            alt="Accounts"
            className="technical__card-image"
          />
          <h2 className="technical__card-title">Accounts</h2>
          <Link to="/ques" className="technical__start-btn">
            Start Test
          </Link>
        </div>
      </div>

      {/* Footer */}
      <footer className="technical__footer">© 2025 Vienstereoptic. All rights reserved.</footer>
    </div>
  );
};

export default MockTest;
